module.exports = __webpack_public_path__ + "static/media/portalweb.3897de4a.jpeg";